<template>
  <v-dialog v-model="dialog" persistent max-width="490">
    <v-card class="px-2 py-2">
      <div class="d-flex align-center">
        <p class="text-left color-darkGray px-4 py-6" style="font-size: 18px">
          Se você é paciente <span class="font-weight-bold">Medicare</span> ou se é funcionário da
          <span class="font-weight-bold">RENOVA</span> envie-nos um e-mail
          para <a href="mailto:geral@ondivan.net" target="_blank">{{ email }}</a> contendo foto do
          seu cartão e o seu número de contato: nós tratamos do agendamento para você!
        </p>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="ok"> Ok </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    email: { type: String },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    ok() {
      this.dialog = false;
      this.$emit('ok');
    },
  },
};
</script>
